import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from '~/components/loader.vue'

import '../node_modules/bootstrap/dist/css/bootstrap.css'

import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'

import '../assets/scss/bootstrap/bootstrap.scss'

import '../assets/css/ldbtn.min.css'

import '../assets/css/fontawesome5/css/all.css'

import '../assets/scss/style.scss'

import '../assets/scss/coupon.scss'

import '../node_modules/vue-select/dist/vue-select.css'

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'

const _7705a157 = () => import('../layouts/about.vue'  /* webpackChunkName: "layouts/about" */).then(m => sanitizeComponent(m.default || m))
const _c0d8e5c0 = () => import('../layouts/default-taxi.vue'  /* webpackChunkName: "layouts/default-taxi" */).then(m => sanitizeComponent(m.default || m))
const _6f6c098b = () => import('../layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => sanitizeComponent(m.default || m))
const _1b52f630 = () => import('../layouts/details-page.vue'  /* webpackChunkName: "layouts/details-page" */).then(m => sanitizeComponent(m.default || m))
const _1c58b071 = () => import('../layouts/detailsPage-withoutFooter.vue'  /* webpackChunkName: "layouts/detailsPage-withoutFooter" */).then(m => sanitizeComponent(m.default || m))
const _00f1563b = () => import('../layouts/detailsPage.vue'  /* webpackChunkName: "layouts/detailsPage" */).then(m => sanitizeComponent(m.default || m))
const _2d2495d5 = () => import('../layouts/home.vue'  /* webpackChunkName: "layouts/home" */).then(m => sanitizeComponent(m.default || m))
const _78595a10 = () => import('../layouts/internal-taxi.vue'  /* webpackChunkName: "layouts/internal-taxi" */).then(m => sanitizeComponent(m.default || m))
const _db79c9d2 = () => import('../layouts/nothing.vue'  /* webpackChunkName: "layouts/nothing" */).then(m => sanitizeComponent(m.default || m))
const _2c37558c = () => import('../layouts/regitration.vue'  /* webpackChunkName: "layouts/regitration" */).then(m => sanitizeComponent(m.default || m))
const _77fdc6c1 = () => import('../layouts/rules.vue'  /* webpackChunkName: "layouts/rules" */).then(m => sanitizeComponent(m.default || m))

let resolvedLayouts = {}
const layouts = { "_about": _7705a157,"_default-taxi": _c0d8e5c0,"_default": _6f6c098b,"_details-page": _1b52f630,"_detailsPage-withoutFooter": _1c58b071,"_detailsPage": _00f1563b,"_home": _2d2495d5,"_internal-taxi": _78595a10,"_nothing": _db79c9d2,"_regitration": _2c37558c,"_rules": _77fdc6c1 }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    async errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        await this.loadLayout(errorLayout)

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    },
  },

  components: {
    NuxtLoading
  }
}
